let LOADING_QR = 'QRを読み込み中';

export default {
  LOADING_QR,
};
